var React = require('react');

function Wand (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"64","height":"64","rx":"4","fill":"#1B68FF","key":0}),React.createElement("path",{"d":"M30 22l1-2 2-1-2-1-1-2-1 2-2 1 2 1 1 2zm-9 4l1.67-3.33L26 21l-3.33-1.67L21 16l-1.67 3.33L16 21l3.33 1.67L21 26zm22 8l-1.67 3.33L38 39l3.33 1.67L43 44l1.67-3.33L48 39l-3.33-1.67L43 34zm4.41-12.11l-5.3-5.3a1.99 1.99 0 00-2.83 0l-22.7 22.7a2 2 0 000 2.82l5.3 5.3a2 2 0 002.84 0l22.7-22.7a2 2 0 000-2.82zm-8.94 6.83l-3.19-3.19 5.42-5.4 3.18 3.17-5.41 5.42z","fill":"#fff","key":1})]);
}

Wand.defaultProps = {"viewBox":"0 0 64 64","fill":"none"};

module.exports = Wand;

Wand.default = Wand;
